import './style.css';
import { useEffect, useState } from 'react';
import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro';
import {
  Banner,
  HelpIcon,
  LoadingIndicator,
  useNotificationsStore
} from '@thermon-platforms/thermon-ui-core';
import api from 'util/api';
import useLicenseStore from 'store/license';
import useDevicesStore from 'store/devices';
import { getConfigItem } from 'util/device';


function License() {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const [error, setError] = useState();
  const [, notificationsStoreActions] = useNotificationsStore();
  const [licenseStore, licenseStoreActions] = useLicenseStore();
  const [devicesStore, devicesStoreActions] = useDevicesStore();
  const [site, setSite] = useState();

  useEffect(() => {
    setLoading(licenseStore.loading);
  }, [licenseStore]);

  useEffect(() => {
    if (!devicesStore.devices.length) return;
    devicesStoreActions.fetchDetail(devicesStore.devices.find(d => d.type == 'Site')?.id).then((detail) => {
      setSite(detail);
    });
  }, [devicesStore]);

  function handleUpload() {
    const formData = new FormData();
    formData.append('licenseFile', file, file.name);
    setError(undefined);
    setLoading(true);

    api(`/auth/license`, {
      method: 'POST',
      body: formData,
      headers: {
        // This is an awkward hack to remove the Content-Type
        // header which let's the browser select the correct
        // type for upload. Unfortunately, just setting it to
        // multipart/form-data; doesn't work
      }
    })
      .then(async res => {
        const expiry = await res.json();
        setFile(undefined);
        if (expiry > 0) {
          licenseStoreActions.query();
          notificationsStoreActions.clearGlobalNotification();
        } else {
          setError(t`License file is invalid or expired`);
        }
      })
      .catch(() => {
        setError(t`License upload failed`);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <div className="view license">
      <header>
        <h2><Trans>License</Trans></h2>
      </header>
      <section>
        <Banner status="alert" show={error}>
          {error}
        </Banner>
        <p>
          <Trans>Current license expires in</Trans>&nbsp;
          {!licenseStore.loading ? <strong>{licenseStore.expiration}</strong> : <LoadingIndicator show={true} />}
          &nbsp;<Trans>days</Trans>.
        </p>
        <br />
        <ul className="form">
          <li>
            <label htmlFor="license-upload">
              <Trans>Update License</Trans>
            </label>
            <input
              type="file"
              id="license-upload"
              accept=".genesisnetworklicense"
              onChange={event => setFile(event.target.files[0])}
              disabled={loading}
            />
          </li>
          <li>
            <Trans>Your site id is:</Trans> <strong>{site ? getConfigItem(site, 'SiteId')?.value : ''}</strong>
            <HelpIcon text={t`The site ID is required when requesting a new license file.`} />
          </li>
          <li>
            <button
              className={`primary ${loading ? 'processing' : ''}`}
              disabled={loading || !file}
              onClick={handleUpload}
            >
              <Trans>Upload License</Trans>
            </button>
          </li>
        </ul>
      </section>
    </div>
  )
}

export default License;
